import React, { useState, useRef, useEffect } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from "react-router-dom";

import { getFlags, logout } from '../../routes/UserAction';

import { domain, reduceText } from '../../data/dummyData';
let url =  domain;



const Header = (props) => {

    const dispatch = useDispatch();
    const {
        loading,
        user,
        error,
        success,
        successMessage,
    } = useSelector((state) => state.user || {});
    const userData = user;                                            
    //   console.log(userData)

    const handleLogout = () => { 
        dispatch(logout()).then(() => {
            localStorage.clear();
            // navigate('/login');
        });
    };

    const [flags, setFlags] = useState([]);
    const fetchFlags = () => {
        dispatch(getFlags())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setFlags(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchFlags();
    }, [])



    const navigate = useNavigate();
    const navigateToRoute = (url) => {
        // 👇️ navigate to /contacts
        navigate(url);
    };

    return (
        <>
        {/* <!-- Navbar & Hero Start --> */}
            <div className="container-fluid header-top">
                <div className="nav-shaps-2"></div>
                
                <div className="container d-flex align-items-center">
                    <div className="d-flex align-items-center h-100">
                        <Link to={'/'} className="navbar-brand" style={{height: '125px'}}>
                            {/* <h1 className="text-primary mb-0"><i className="fas fa-hand-rock me-2"></i> MJ-EMYLAB</h1> */}
                            <h1 className="text-primary mb-0"><img className="mb-1" style={{width: 70, height: 90}} src={props?.subpage? "../assets/img/emy.png":"./assets/img/emy.png"} alt="Logo"/> MJ-EMYLAB</h1>
                            
                        </Link>
                    </div>
                    <div className="w-100 h-100">
                        <div className="topbar px-0 py-2 d-none d-lg-block" style={{height: '45px'}}>
                            <div className="row gx-0 align-items-center">
                                <div className="col-lg-8 text-center text-lg-center mb-lg-0">
                                    <div className="d-flex flex-wrap">
                                        <div className="pe-4">
                                        <a 
                                            href={`mailto:${flags?.find(el => el.name === 'emy_email' && el.   type === 1)?.value || 'info@mj-emylab.com'}`}
                                            className="text-white small"
                                        >
                                            <i className="fas fa-envelope text-primary me-2"></i>
                                            {flags?.find(el => el.name === 'emy_email' && el.type === 1)?.value || 'info@mj-emylab.com'}
                                        </a>
                                        </div>
                                        <div className="pe-0">
                                        <a
                                            href="#"
                                            className="text-white small"
                                        >
                                            <i className="fa fa-clock text-primary me-2"></i>
                                            {flags?.find(el => el.name === 'emy_hours' && el.type === 1)?.value || 'Sun - Mon: 8:00 am-10:00 pm'}
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 text-center text-lg-end">
                                    <div className="d-flex justify-content-end">
                                        <div className="d-flex align-items-center small">

                                            {userData && (userData?.first_name !== '' || userData?.first_name !== null)?    
                                                <Link to={'/profile'} className="login-btn text-body me-3 pe-3"><span className="text-white">{userData?.username}</span></Link>
                                            : <>
                                                <Link to={'/login'} className="login-btn text-body me-3 pe-3"><span className="text-white">Login</span></Link>
                                                <Link to={'/register'} className="me-3 text-white">Register</Link>
                                                </>
                                            }

                                            
                                        </div>
                                        <div className="d-flex pe-3">
                                            <a
                                                className="btn p-0 text-primary me-3"
                                                href={
                                                flags?.find(el => el.name === 'emy_facebook' && el.type === 1)?.value || '#'
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-facebook-f"></i>
                                            </a>
                                            <a
                                                className="btn p-0 text-primary me-3"
                                                href={
                                                flags?.find(el => el.name === 'emy_x' && el.type === 1)?.value || '#'
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="">X</i>
                                            </a>
                                            <a
                                                className="btn p-0 text-primary me-3"
                                                href={
                                                flags?.find(el => el.name === 'emy_tiktok' && el.type === 1)?.value || '#'
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-tiktok"></i>
                                            </a>
                                            <a
                                                className="btn p-0 text-primary me-0"
                                                href={`mailto:${
                                                flags?.find(el => el.name === 'emy_email' && el.type === 1)?.value || 'info@mj-emylab.com'
                                                }`}
                                            >
                                                <i className="fas fa-envelope"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="nav-bar px-0 py-lg-0" style={{height: '80px'}}>
                            <nav className="navbar navbar-expand-lg navbar-light d-flex justify-content-lg-end">
                                <Link to={'/'} className="navbar-brand-2">
                                    {/* <h1 className="text-primary mb-0"><i className="fas fa-hand-rock me-2"></i> MJ-EMYLAB</h1> */}
                                    <h1 className="text-primary mb-0"><img style={{width: 50, height: 60}} src={props?.subpage? "../assets/img/emy.png":"./assets/img/emy.png"} alt="Logo"/> MJ-EMYLAB</h1>
                                </Link> 
                                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                                    <span className="fa fa-bars"></span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarCollapse">
                                    <div className="navbar-nav mx-0 mx-lg-auto">
                                        <Link to={'/'} className={props.page==='home'? "active nav-item nav-link": 'nav-item nav-link'}>Home</Link>
                                        <Link to={'/about'} className={props.page==='about'? "active nav-item nav-link": 'nav-item nav-link'}>About</Link>
                                        <Link to={'/programs'} className={props.page==='program'? "active nav-item nav-link": 'nav-item nav-link'}>Programs</Link>
                                        <Link to={'/projects'} className={props.page==='project'? "active nav-item nav-link": 'nav-item nav-link'}>Projects</Link>
                                        <Link to={'/blogs'} className={props.page==='blog'? "active nav-item nav-link": 'nav-item nav-link'}>Blogs</Link>
                                        <Link to={'countries'} className={props.page==='country'? "active nav-item nav-link": 'nav-item nav-link'}>Countries</Link>

                                        <div className="nav-item dropdown">
                                            <a href="#" className="nav-link" data-bs-toggle="dropdown">
                                                <span className="dropdown-toggle">Pages</span>
                                            </a>
                                            <div className="dropdown-menu">
                                            <Link to={'/researches'} className="dropdown-item">Researches</Link>
                                            <Link to={'/departments'} className="dropdown-item">Departments</Link>
                                            <Link to={'/api'} className="dropdown-item">APIs</Link>

                                            </div>
                                        </div>
                                        <Link to={'/contact'} className={props.page==='contact'? "active nav-item nav-link": 'nav-item nav-link'}>Contact</Link>
                                        <Link to={'/jobs'} className={props.page==='job'? "active nav-item nav-link": 'nav-item nav-link'}>Jobs</Link>
                                        <Link to={'/chat'} className={props.page==='chat'? "active nav-item nav-link": 'nav-item nav-link'}>Chats</Link>
                                        <div className="nav-btn ps-3">
                                            <button className="btn-search btn btn-primary btn-md-square mt-2 mt-lg-0 mb-4 mb-lg-0 flex-shrink-0" data-bs-toggle="modal" data-bs-target="#searchModal"><i className="fas fa-search"></i></button>

                                            {userData && (userData?.first_name !== '' || userData?.first_name !== null)?    
                                                <><Link to={'/profile'} className="btn btn-primary py-2 my-1 px-2 ms-0 ms-lg-3"> <span>Profile</span></Link>
                                                <button type="button" onClick={handleLogout} className="btn btn-primary py-2 my-1 px-2 ms-0 ms-lg-3"> <span>Logout</span></button></>
                                            : <>
                                                <Link to={'/login'} className="btn btn-primary py-2 my-1 px-2 ms-0 ms-lg-3"> <span>Login</span></Link>
                                                <Link to={'/register'} className="btn btn-primary py-2 my-1 px-2 ms-0 ms-lg-3"> <span>Register</span></Link>
                                                </>
                                            }
                                            
                                        </div>
                                        <div className="nav-shaps-1"></div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Navbar & Hero End --> */}

            {/* <!-- Modal Search Start --> */}
            <div className="modal fade" id="searchModal" tabIndex="-1" ariaLabelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content rounded-0">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Search by keyword</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body d-flex align-items-center bg-primary">
                            <div className="input-group w-75 mx-auto d-flex">
                                <input type="search" className="form-control p-3" placeholder="keywords" aria-describedby="search-icon-1"/>
                                <span id="search-icon-1" className="btn bg-light border nput-group-text p-3"><i className="fa fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Modal Search End --> */}
        </>
    )
}

export default Header
